import { AnimatePresence, motion } from "framer-motion"
import React from "react"

interface VerticalExpandAnimationProps {
  children: any
  show: boolean
}

const VerticalExpandAnimation: React.FC<VerticalExpandAnimationProps> = ({
  children,
  show,
}) => {
  return (
    // @ts-ignore
    <AnimatePresence>
      {show && (
        <motion.div
          animate={{ transform: "scaleY(1)" }}
          exit={{ transform: "scaleY(0)" }}
          initial={{ transform: "scaleY(0)" }}
          key="mega-menu"
          transition={{ duration: 0.15 }}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default VerticalExpandAnimation
